<script setup lang="ts">
import { computed, ref } from 'vue'

type Props = {
  src: string | null
  width: string
  height: string
  userName?: string
  userSurname?: string
}
const props = defineProps<Props>()
const img = ref()
const isError = ref(false)
const errorSrc = (e: any) => {
  e.target.src = '/images/no-avatar.png'
}
const style = computed(() => ({
  width: `${props.width}px`,
  height: `${props.height}px`,
  maxWidth: `${props.width}px`,
  maxHeight: `${props.height}px`
}))
</script>

<template>
  <div class="rounded-full overflow-hidden" :style="style">
    <img
      ref="img"
      @error="errorSrc"
      class="w-full h-full"
      :src="props.src || '/images/no-avatar.png'"
      alt=""
    />
  </div>
</template>
